import { CommonModule } from '@angular/common';
import { CUSTOM_ELEMENTS_SCHEMA, NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms'; //is this needed here.  can we/should we export from the app module?
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { DirectiveModule } from '@Shared/Directives/proprietary/directive.module';
//import { FormControlModule } from 'src/app/controls/form-controls/form-control.module';
import { DynamicContentOutletModule } from '@Work/Accounts/proprietary/dynamic-content-outlet/dynamic-content-outlet.module';
import { SectionNavigatorComponent } from './section-navigator/section-navigator.component';
import { SectionRendererComponent } from './section-renderer/section-renderer.component';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        DynamicContentOutletModule,
        //FormControlModule,
        NgbDropdownModule,
        NgbTooltipModule,
        DirectiveModule
    ],
    declarations: [SectionNavigatorComponent, SectionRendererComponent],
    exports: [SectionNavigatorComponent, SectionRendererComponent],
    schemas: [CUSTOM_ELEMENTS_SCHEMA]
})
export class SectionControlModule { }
